import {AuthStorage} from './auth-storage';
import {Module, Role} from '../model/profile';
import {ControlPanelSettingsEntry} from '../model/control-panel-settings.entry';

export class Permissions {

  public static hasRoles(roles: Role[]): boolean {
    if (roles) {
      let userRole: any = AuthStorage.getUserRole();
      return roles.filter(x => Role[x] === userRole).length > 0;
    }
    return true;
  }

  public static hasRole(role: Role): boolean {
    let userRole: any = AuthStorage.getUserRole();
    return Role[role] === userRole;
  }

  public static hasModules(modules: string[]): boolean {
    let userModules: string[] = AuthStorage.getModules();
    if (modules && userModules.length > 0) {
      return userModules.filter(x => x === modules[0]).length > 0;
    } else {
      return !(modules && userModules.length === 0);
    }
  }

  public static hasModule(module: string): boolean {
    let userModules: string[] = AuthStorage.getModules();
    if (userModules != null && userModules.length > 0) {
      return userModules.filter(x => x === module).length > 0;
    }
  }

  public static isSubcontractor(): boolean {
    return AuthStorage.isLoggedClientContractor();
  }

  public static canShowLiveTacho(isPartnerTrack: boolean): boolean {
    let cpSettings: ControlPanelSettingsEntry = AuthStorage.getControlPanelSettings();
    let partnerTacho = !isPartnerTrack &&
      !AuthStorage.isLoggedClientEmployee()
      && this.hasModule(Module.HEAVY_TRACK);
    let clientTacho = cpSettings && cpSettings.tachoTime;
    return partnerTacho || clientTacho;
  }
}
